const WORDS = ["Shot zones", "Combine benchmarks", "Depth charts", "Program trajectory", "Recruiter boards", "Box scores", "Coach ↔ recruiter DMs", "Printable reports"];

export const Marquee = () => (
  <section aria-label="Feature ticker" className="relative overflow-hidden border-y border-white/5 bg-[#0F172A] py-8">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {WORDS.map((w) => (
            <span key={`${k}-${w}`} className="flex items-center font-display text-5xl font-extrabold uppercase italic tracking-tight text-white sm:text-7xl">
              <span className="px-8">{w}</span>
              <img src="/logo-mark.png" alt="" className="h-8 w-auto opacity-80 sm:h-10" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
